import { Controller } from "@hotwired/stimulus"

// Submits the form whenever any of its inputs fires `change`.
// Used for live-updating turbo-stream forms (e.g. payment page).
export default class extends Controller {
  connect() {
    this._listener = this.handleChange.bind(this)
    this.element.addEventListener("change", this._listener)
  }

  disconnect() {
    this.element.removeEventListener("change", this._listener)
  }

  handleChange(event) {
    const target = event.target
    if (!target || target.type === "submit") return
    if (target.dataset.formAutosubmitSkip === "true") return

    // Bypass HTML5 validation so partial updates don't require the whole
    // form (email, address, etc.) to be filled. We toggle `novalidate`
    // around the requestSubmit call so a normal user-initiated submit on
    // the CTA still validates required fields.
    const wasNovalidate = this.element.noValidate
    this.element.noValidate = true
    try {
      this.element.requestSubmit()
    } finally {
      this.element.noValidate = wasNovalidate
    }
  }
}
